import { createFeatureSelector, createSelector } from '@ngrx/store';
import { StoreState } from 'src/app/core/enums/store-state';
import {
  InstitutionsState,
  institutionsFeatureKey,
} from './institutions.reducer';

export const selectInstitutionsStoreState =
  createFeatureSelector<InstitutionsState>(institutionsFeatureKey);

export const selectInstitutions = createSelector(
  selectInstitutionsStoreState,
  (state) => state.institutions || []
);

export const selectTotal = createSelector(
  selectInstitutionsStoreState,
  (state) => state.total || 0
);

export const selectInstitutionsFilterInput = createSelector(
  selectInstitutionsStoreState,
  (state) => state.filterInput || {}
);

export const institutionsLoading = createSelector(
  selectInstitutionsStoreState,
  (state) => state.institutionsState === StoreState.inProgress
);
